module.exports = "https://coursera_assets.s3.amazonaws.com/images/2620acf9f190b76065b4aac1ecee0c44.png";